import React, { useState, useRef, useEffect } from 'react';
import { useForm } from "react-hook-form";
import {
    DialogContent, DialogTitle, Dialog,
    Paper, TextField, Box, Grid, TableCell, TableContainer, Typography, Card, CardContent,
    Table, TableHead, Button, IconButton, FormControl,
    InputLabel, TableRow, TableBody, Select, MenuItem, FormControlLabel, Radio, RadioGroup, Snackbar, Tooltip, Autocomplete,
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import axios from 'axios'
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { BootstrapDialog, BootstrapDialogTitle } from '../../reusableComponent/BootstrapDialog'
import { ERPinput, ERPinputNo } from '../../reusableComponent/ErpTextField';
import { addItem, editDeleteItem, getBinList, getCategoryList, getUnitList } from '../../../actions/actions';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { dateConversionOnEntryPage } from '../../reusableComponent/dateConversionOnEntryPage';
import styles from '.././../../styles.module.css';
import Breadcrumb from '../../reusableComponent/Breadcrumb';
import { BackBtn, Cancel } from '../../reusableComponent/BackBtn';

const useStyles = makeStyles({
    option: {
        fontSize: 12,
    },
    noOptionsLabel: {
        fontSize: '12px', // Set the desired font size
    },
});


function ItemAdd(props) {
    const classes = useStyles();
    const dispatch = useDispatch()
    const { handleSubmit } = useForm();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    const [successMessage, setSuccessMessage] = useState(null);

    let navigate = useNavigate();
    const location = useLocation();
    // const editInfo = props.details;
    const urlLocation = useLocation();
    const editInfo = urlLocation.state;
    const editData = editInfo && editInfo;
    const editid = editData && editData.itemId;
    const [unitName, setUnitName] = useState(editData ? editData.unit : null)
    const [category, setCategory] = useState(editData ? editData.category : null)
    const [open, setOpen] = React.useState(false);
    const [openSnak, setOpenSnak] = React.useState(false);
    const [binNo, setBinNo] = useState(editData ? editData.binNo : null);

    const [data, setData] = useState({
        id: editid,
        itemName: editData ? editData.itemName : '',
        itemType: editData ? editData.itemType : 'Finished Good',
        itemCode: editData ? editData.itemCode : '',
        itemDescription: editData ? editData.itemDescription : '',
        openingStock: editData ? editData.openingStock : 0,
        minimumStock: editData ? editData.minimumStock : 0,
        maximumStock: editData ? editData.maximumStock : 0,
        leadTime: editData ? editData.leadTime : 0,
        lowStockAlert: editData ? editData.lowStockAlert : 0,
        rate: editData ? editData.rate : 0,
        moq: editData ? editData.moq : 1,
        gst: editData ? editData.gst : '',
        hsnCode: editData ? editData.hsnCode : '',
        // binNo: editData ? editData.binNo == undefined ? null : editData.binNo._id : null,
    });


    const unitList = useSelector(state => state.unit.unit)
    const categoryList = useSelector(state => state.category.category)
    const binList = useSelector(state => state.bin.bin)

    useEffect(() => {
        dispatch(getUnitList({ companyId: userInfo.companyId }))
        dispatch(getCategoryList({ companyId: userInfo.companyId }))
        dispatch(getBinList({ companyId: userInfo.companyId }))

        if (editData) {
            setUnitName({
                unitName: editData.unit,
                id: editData.unit
            })
            setCategory({
                categoryName: editData.categoryName,
                id: editData.category
            })
            setBinNo({
                binNo: editData.binNumber,
                id: editData.binNo
            })
        }

    }, []);

    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.item.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                if (responseMessage === 'Item name already available!') {
                    setSuccessMessage(responseMessage)
                    setShouldShowMsg(false);
                    dispatch({ type: 'RESET_MESSAGE' });
                    setTimeout(() => {
                        setSuccessMessage(false)
                    }, 2000)

                } else {
                    setShouldShowMsg(true);
                    navigate(-1, { responseMessage });
                }
            }
        }
    }, [shouldShowMsg, responseMessage]);
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (editData) {
            if (reason !== 'backdropClick') {
                setOpen(false);
            }
        } else {
            if (data.itemName == '' &&
                data.category == '' &&
                data.itemCode == '' &&
                data.itemDescription == '' &&
                data.leadTime == '' &&
                data.lowStockAlert == '' &&
                data.rate == '' &&
                data.moq == '' &&
                data.gst == '' &&
                data.hsnCode == '') {
                setOpen(false);
                setOpenSnak(false);
            } else {
                setOpenSnak(true)
            }
        }
    };

    const handleOpenSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setData({
            itemName: '',
            itemType: '',
            category: '',
            itemCode: '',
            itemDescription: '',
            openingStock: 0,
            minimumStock: 0,
            maximumStock: 0,
            leadTime: '',
            lowStockAlert: '',
            rate: '',
            moq: '',
            gst: '',
            hsnCode: '',
            unitName: '',
        })
        setOpenSnak(false);
        setOpen(false);
    }

    const handleCloseSnak = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnak(false);
    };

    const handleChangeUnit = (event, newValue) => {
        setUnitName(newValue)
    }

    const handleChangeCategory = (event, newValue) => {
        setCategory(newValue)
    }

    const handleChangeBin = (event, newValue) => {
        setBinNo(newValue)
    }

    const handleChange = ({ target }) => {
        const value = target.value;
        setData({
            ...data,
            [target.name]: value,
        });
        data[target.name] = target.value;
    }

    const clearInputFields = () => {
        setBinNo(null);
        setData({
            itemName: '',
            itemType: '',
            category: '',
            itemCode: '',
            itemDescription: '',
            openingStock: 0,
            minimumStock: 0,
            maximumStock: 0,
            leadTime: '',
            lowStockAlert: '',
            rate: '',
            moq: '',
            gst: '',
            hsnCode: '',
            unitName: '',
        });
    };
    const onSubmit = (event) => {

        let sendData = {
            ...data,
            unit: unitName.unitName,
            binNo: binNo == null ? null : binNo.id,
            category: category.id,
            companyId: userInfo.companyId,
            createdBy: editData ? editData.createdBy : userInfo.userId,
            createdAt: editData ? editData.createdAt : dateConversionOnEntryPage(new Date()),
            modifiedBy: editData ? userInfo.userId : null,
            modifiedAt: editData ? dateConversionOnEntryPage(new Date()) : '',
            changedUpdatedValue: 'edit',
        }
        if (editData) {
            dispatch(editDeleteItem(sendData));
        } else {
            dispatch(addItem(sendData));
        }
        // props.onAPISubmt();
        // props.handleCloseDialog();
        // clearInputFields();
    }
    const action = (
        <React.Fragment>
            <Button size="small" id="btnYes" onClick={handleOpenSnack}>
                Yes
            </Button>
            <Button size="small" id="btnNo" onClick={handleCloseSnak}>
                No
            </Button>
        </React.Fragment>
    );

    return (
        <>
            <div>
            <Breadcrumb
                            routeSegments={[
                                { name: 'Masters', path: '/masters/' },
                                { name: 'Item List', path: '/masters/item-masters' },
                                { name: 'Create Item' },
                            ]}
                        />
                <Paper className={`${styles.list_container}`}>
                  
                  
                     <Box sx={{ m: 4}} > </Box>

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={1} sx={{ mt: 0, paddingLeft: '30px' }}>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`} >Item Type</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    required
                                    fullWidth
                                    name="itemType"
                                    value={data.itemType}
                                    type="text"
                                    size='small'
                                    onChange={handleChange}
                                    select
                                >
                                    <MenuItem value="Finished Good" className={`${styles.erp_lable}`}>Finished Good</MenuItem>
                                    <MenuItem value="Raw Material" className={`${styles.erp_lable}`}>Raw Material</MenuItem>
                                    <MenuItem value="Bought-Out" className={`${styles.erp_lable}`}>Bought-Out</MenuItem>
                                    <MenuItem value="Scrap" className={`${styles.erp_lable}`}>Scrap</MenuItem>
                                </ERPinput>
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Item Code / Part No </Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    required
                                    fullWidth
                                    type="text"
                                    onChange={handleChange}
                                    name="itemCode"
                                    value={(data.itemCode)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}

                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Item Name</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    required
                                    size='small'
                                    fullWidth
                                    name="itemName"
                                    type="text"
                                    onChange={handleChange}
                                    value={(data.itemName)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}> Item Description</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    size='small'
                                    fullWidth
                                    name="itemDescription"
                                    type="text"
                                    onChange={handleChange}
                                    value={(data.itemDescription)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Category</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <Autocomplete
                                    fullWidth
                                    classes={{
                                        option: classes.option,
                                    }}
                                    noOptionsText={
                                        <span className={classes.noOptionsLabel}>No options</span>
                                    }
                                    options={categoryList}
                                    value={category}
                                    onChange={handleChangeCategory}
                                    getOptionLabel={(option) => option.categoryName}
                                    getOptionSelected={(option, value) => option.id === value.id} // set value to option id
                                    renderInput={(params) => <ERPinput required {...params} />}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Unit</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <Autocomplete
                                    fullWidth
                                    classes={{
                                        option: classes.option,
                                    }}
                                    noOptionsText={
                                        <span className={classes.noOptionsLabel}>No options</span>
                                    }
                                    options={unitList}
                                    value={unitName}
                                    onChange={handleChangeUnit}
                                    getOptionLabel={(option) => option.unitName}
                                    getOptionSelected={(option, value) => option.unitName === value.unitName} // set value to option id
                                    renderInput={(params) => <ERPinput required {...params} />}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>HSN Code</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    required
                                    size='small'
                                    fullWidth
                                    type="text"
                                    onChange={handleChange}
                                    name="hsnCode"
                                    value={(data.hsnCode)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>GST %</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinputNo
                                    required
                                    size='small'
                                    fullWidth
                                    name="gst"
                                    type="number"
                                    onChange={handleChange}
                                    value={(data.gst)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{
                                        min: 0,
                                        max: 100,
                                        step: 1,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}> Rate</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinputNo
                                    size='small'
                                    fullWidth
                                    name="rate"
                                    type="number"
                                    onChange={handleChange}
                                    value={(data.rate)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>MOQ</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinputNo
                                    size='small'
                                    fullWidth
                                    name="moq"
                                    type="number"
                                    onChange={handleChange}
                                    value={(data.moq)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}> Bin No</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <Autocomplete
                                    fullWidth
                                    classes={{
                                        option: classes.option,
                                    }}
                                    noOptionsText={
                                        <span className={classes.noOptionsLabel}>No options</span>
                                    }
                                    options={binList}
                                    value={binNo}
                                    onChange={handleChangeBin}
                                    getOptionLabel={(option) => option.binNo}
                                    getOptionSelected={(option, value) => option.id === value.id} // set value to option id
                                    renderInput={(params) => <ERPinput required {...params} />}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Opening Stock</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinputNo
                                    size='small'
                                    fullWidth
                                    type="number"
                                    onChange={handleChange}
                                    name="openingStock"
                                    value={(data.openingStock)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Minimum Stock</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinputNo
                                    size='small'
                                    fullWidth
                                    name="minimumStock"
                                    type="number"
                                    onChange={handleChange}
                                    value={(data.minimumStock)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Maximum Stock</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinputNo
                                    size='small'
                                    fullWidth
                                    name="maximumStock"
                                    type="number"
                                    onChange={handleChange}
                                    value={(data.maximumStock)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Low Stock Alert</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    size='small'
                                    fullWidth
                                    name="lowStockAlert"
                                    type="text"
                                    onChange={handleChange}
                                    value={(data.lowStockAlert)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={2} className={`${styles.grid_lable}`}>
                                <Typography className={`${styles.erp_lable}`}>Lead Time(In Days)</Typography>
                            </Grid>
                            <Grid item xs={4} className={`${styles.grid_input}`}>
                                <ERPinput
                                    size='small'
                                    fullWidth
                                    name="leadTime"
                                    type="text"
                                    onChange={handleChange}
                                    value={(data.leadTime)}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} className={`${styles.grid_input}`}>
                                <Box sx={{ marginTop: '12px', float: 'right' }}>
                                    <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                    <SaveIcon style={{ fontSize: '16px', marginRight: '10px' }} /> {editData ? 'Update' : 'Save'}
                                    </Button>
                                    <Cancel />
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </Paper>
                <Snackbar
                    open={openSnak}
                    autoHideDuration={4000}
                    onClose={handleCloseSnak}
                    message="Do you wish to close without saving ?"
                    action={action}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                />
                 {successMessage &&
                    <Snackbar
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        open={successMessage}
                        autoHideDuration={2000}
                        message={successMessage}
                    />
                }
            </div>
        </>
    )
}

export default ItemAdd